import { redirect, type LoaderFunctionArgs } from "react-router";
import { sessionContext } from "../lib/session.js";
import { lastWorkspaceSlug } from "../lib/workspace.js";
import { ShellSkeleton } from "./workspace/layout.jsx";
import { InboxSkeleton } from "./workspace/inbox.jsx";

// "/" for a signed-in user: last workspace, else first, else create one.
export async function appIndexLoader({ context }: LoaderFunctionArgs) {
  const me = context.get(sessionContext);
  const workspaces = me?.workspaces ?? [];
  if (workspaces.length === 0) return redirect("/workspaces/new");
  const last = lastWorkspaceSlug();
  const target = workspaces.find((w) => w.slug === last) ?? workspaces[0]!;
  return redirect(`/w/${target.slug}`);
}

/** Where "/" leads is known only once the session is read; the last workspace's Inbox is the usual answer. */
export function AppIndexSkeleton() {
  const slug = lastWorkspaceSlug();
  return slug ? (
    <ShellSkeleton slug={slug}>
      <InboxSkeleton />
    </ShellSkeleton>
  ) : null;
}
